<div class="justup-dialog-large">
  <vl-dialog-header-export
    [exporting]="exporting()"
    (close)="dialogRef.close()"
    (export)="exportExcel()">
    Couverture des commandes — {{ horizonLabel() }}
  </vl-dialog-header-export>

  <div class="justup-dialog-content flex-col gap-16">
    <!-- ═══ Stats cards ═══ -->
    <div class="flex-row gap-8 wrap">
      <vl-radio-card mode="display" color="valid" icon="check_circle"
                     title="Couverts" style="flex: 1; min-width: 130px">
        <span content class="headline">{{ stats().nbCouvert }}</span>
      </vl-radio-card>
      <vl-radio-card mode="display" color="secondary" icon="pending_actions"
                     title="À réserver" style="flex: 1; min-width: 130px">
        <span content class="headline">{{ stats().nbAReserver }}</span>
      </vl-radio-card>
      <vl-radio-card mode="display" color="error" icon="error"
                     title="En manque" style="flex: 1; min-width: 130px">
        <span content class="headline">{{ stats().nbManque }}</span>
      </vl-radio-card>
      <vl-radio-card mode="display" color="basic" icon="donut_large"
                     title="Couvrable" style="flex: 1; min-width: 130px">
        <span content class="headline">{{ stats().couvrablePct }} %</span>
      </vl-radio-card>
    </div>
    <div class="caption on-background-alt flex-row gap-16 wrap">
      <span>À réserver maintenant : <strong>{{ stats().totalReserver | number:'1.0-0' }}</strong> u</span>
      <span>Manquant (à produire / acheter) : <strong class="on-error">{{ stats().totalManque | number:'1.0-0' }}</strong> u</span>
      <span>{{ stats().nbProduits }} produits suivis</span>
    </div>

    <!-- ═══ Filtre statut ═══ -->
    <div class="flex-row justify-center">
      <vl-chips-toggle
        [elements]="filterOptions"
        [value]="filter()"
        (valueChange)="filter.set($any($event))"
        size="small"/>
    </div>

    <!-- ═══ Table ═══ -->
    <div class="couv-table-wrapper">
      <table class="couv-table">
        <thead>
          <tr>
            <th class="left">Statut</th>
            <th class="left">Article</th>
            <th class="right">Commandé</th>
            <th class="right">Déjà réservé</th>
            <th class="right">Stock éligible</th>
            <th class="right">À réserver</th>
            <th class="right">Manque</th>
            <th class="right">% couvr.</th>
            <th class="right">Cmd</th>
            <th class="center">Expédition</th>
            <th class="center">Livraison</th>
          </tr>
        </thead>
        <tbody>
          @for (l of lines(); track l.row.articleId) {
            <tr class="cursor-pointer"
                (click)="openProduit(l)"
                matTooltip="Ouvrir la grille de réservation">
              <td class="left">
                <span class="statut-badge"
                      [class.badge-manque]="l.statut === 'MANQUE'"
                      [class.badge-reserver]="l.statut === 'A_RESERVER'"
                      [class.badge-couvert]="l.statut === 'COUVERT'">
                  {{ statutLabel(l.statut) }}
                </span>
              </td>
              <td class="left">
                <div class="flex-col">
                  <span class="body-2 bold">{{ l.row.denomination ?? '—' }}</span>
                  <span class="tiny on-background-alt">
                    @if (l.row.reference) { {{ l.row.reference }} }
                    @if ((l.row.typeDateLimite === 'DDM' || l.row.typeDateLimite === 'DLC')) {
                      · {{ l.row.typeDateLimite }}@if (l.row.dluoJours != null) { {{ l.row.dluoJours }} j}
                    }
                  </span>
                </div>
              </td>
              <td class="right">
                {{ l.row.besoinUG | number:'1.0-0' }}
                <span class="tiny on-background-alt">{{ l.row.uniteArticle ?? 'u.' }}</span>
              </td>
              <td class="right">{{ l.row.engageUG | number:'1.0-0' }}</td>
              <td class="right">{{ l.row.stockEligibleUG | number:'1.0-0' }}</td>
              <td class="right">
                @if (l.reservableNow > 0) {
                  <strong class="on-secondary-text">{{ l.reservableNow | number:'1.0-0' }}</strong>
                } @else { — }
              </td>
              <td class="right">
                @if (l.manque > 0) {
                  <strong class="on-error">{{ l.manque | number:'1.0-0' }}</strong>
                } @else { — }
              </td>
              <td class="right">{{ l.couvrablePct }} %</td>
              <td class="right">{{ l.row.nbCommandes }}</td>
              <td class="center">
                {{ l.row.premiereExpedition ? (l.row.premiereExpedition | date:'dd/MM/yy') : '—' }}
              </td>
              <td class="center">
                {{ l.row.premiereLivraison ? (l.row.premiereLivraison | date:'dd/MM/yy') : '—' }}
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="11" class="center on-background-alt p-16">
                Aucun produit dans ce filtre.
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
